@if (invite) {
  <section
    class="ignosis-transfer"
    [class.ignosis-transfer--dragging]="dragging"
    [style.left.px]="left"
    [style.top.px]="top"
  >
    <header class="ignosis-transfer-header" (mousedown)="startDrag($event)">
      <strong class="ignosis-transfer-label">Transferred call</strong>
      <div class="ignosis-transfer-actions">
        @if (invite.dueId) {
          <a
            class="ignosis-goto-case"
            [href]="'/timeline/' + invite.dueId"
            target="_blank"
            rel="noopener"
            (mousedown)="$event.stopPropagation()"
            (click)="$event.stopPropagation()"
          >Go To Case</a>
        }
        <button
          type="button"
          class="ignosis-decline"
          (mousedown)="$event.stopPropagation()"
          (click)="state === 'joined' ? leave() : decline()"
        >
          {{ state === 'joined' ? 'Leave' : 'Decline' }}
        </button>
      </div>
    </header>
    @if (invite.reason) {
      <p class="ignosis-transfer-reason">{{ invite.reason }}</p>
    }
    @if (!invite.dueId) {
      <p class="ignosis-transfer-muted">No matching case</p>
    }
    @if (notice && !frameUrl) {
      <p class="ignosis-transfer-inline-notice">{{ notice }}</p>
    }
    @if (frameUrl) {
      <div class="ignosis-transfer-frame">
        <iframe #frame [src]="frameUrl" title="Transferred call" allow="microphone; autoplay"></iframe>
      </div>
    }
  </section>
}
@if (notice && !invite) {
  <p class="ignosis-transfer-notice">{{ notice }}</p>
}
